import type { T_ChatV8ConversationTransport } from "@lattice/shared-frontend/chat-v8";
import { trpcClient } from "@lattice/frontend/lib/trpc/client/vanillaClient";

/** Browser tRPC adapter exposing only the operations used by the web client. */
export function createWebChatV8Transport(): T_ChatV8ConversationTransport {
  return {
    answerElicitation: async (input) => {
      const result = await trpcClient.chat_v8.answerElicitation.mutate(input);
      return result.data;
    },
    cancelRun: async (input) => {
      const result = await trpcClient.chat_v8.cancelRun.mutate(input);
      return result.data;
    },
    getCapabilities: async () => {
      const result = await trpcClient.chat_v8.getCapabilities.query();
      return result.data;
    },
    getEvents: async (input) => {
      const result = await trpcClient.chat_v8.getEvents.query(input);
      return result.data;
    },
    getThreadPage: async (input) => {
      const result = await trpcClient.chat_v8.getThreadPage.query(input);
      return result.data;
    },
    getThreadTail: async (input) => {
      const result = await trpcClient.chat_v8.getThreadTail.query(input);
      return result.data;
    },
    getWidgetArtifactSnapshot: async (input) => {
      const result =
        await trpcClient.chat_v8.getWidgetArtifactSnapshot.query(input);
      return result.data;
    },
    requestAttachmentUpload: async (input) => {
      const result =
        await trpcClient.chat_v8.requestAttachmentUpload.mutate(input);
      return result.data;
    },
    sendMessage: async (input) => {
      const result = await trpcClient.chat_v8.sendMessage.mutate(input);
      return result.data;
    },
    streamEvents: (input, handlers) => {
      const subscription = trpcClient.chat_v8.streamEvents.subscribe(
        input,
        handlers,
      );

      return {
        unsubscribe: () => subscription.unsubscribe(),
      };
    },
  };
}
